<script lang="ts">
  import { onMount } from 'svelte';
  import type { ApiClient } from '../lib/api';
  import { formatDate } from '../lib/format';
  import Loading from '../lib/Loading.svelte';
  import type { Router } from '../lib/router.svelte';
  import StatusBadge from '../lib/StatusBadge.svelte';
  import type { Incident, IncidentEvent } from '../lib/types';

  let { api, router, incidentId }: { api: ApiClient; router: Router; incidentId: string } = $props();
  let summary = $state<Incident | null>(null);
  let events = $state<IncidentEvent[]>([]);
  let cursor = $state<string | null>(null);
  let loading = $state(true);
  let error = $state('');

  async function load(next = '') {
    try {
      const result = await api.incident(incidentId, next);
      summary = result.summary; events = next ? [...events, ...result.events] : result.events; cursor = result.nextCursor;
    } catch (reason) { error = reason instanceof Error ? reason.message : 'Incident details could not be loaded.'; }
    finally { loading = false; }
  }
  onMount(() => load());
</script>

<button class="back" onclick={() => router.navigate('/history')}>← Incident history</button>
{#if error}<p class="inline-error" role="alert">{error}</p>{/if}
{#if loading}<Loading />{:else if summary}
  <section class="incident-hero"><div><p class="eyebrow">{summary.customerName}</p><h1>{summary.alarmName}</h1><p>{summary.region} · {summary.accountName} · account {summary.awsAccountId}</p></div><StatusBadge state={summary.status} /></section>
  <dl class="summary-grid"><div><dt>Opened</dt><dd>{formatDate(summary.openedAt)}</dd></div><div><dt>Resolved</dt><dd>{summary.resolvedAt ? formatDate(summary.resolvedAt) : 'Still open'}</dd></div><div><dt>Events</dt><dd>{summary.eventCount}</dd></div><div><dt>Latest reason</dt><dd>{summary.latestReason}</dd></div></dl>
  <section class="detail-section"><h2>Timeline</h2><ol class="timeline">{#each events as event}<li class:stale={event.stale}><div class="timeline-marker" aria-hidden="true"></div><article><header><StatusBadge state={event.newState} /><time>{formatDate(event.occurredAt)}</time></header><p>{event.reason}</p>{#if event.stale}<small>Received out of order and retained without changing incident state</small>{/if}</article></li>{/each}</ol>{#if cursor}<button class="secondary" onclick={() => load(cursor ?? '')}>Load more events</button>{/if}</section>
{/if}
